module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/instagram/sola_sns_01-38e03cea2a0c332aa1069aa9172307f6.jpg";